export const updateUserAction = (state) => {
  return {
    type: "UPDATE_STATE_USER",
    payload: state,
  };
};
